import { Box, useRadio, Tooltip } from "@chakra-ui/react";
import { colorMain } from "../../constants/themes";

export function RadioCard(props) {
  const { getInputProps, getCheckboxProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getCheckboxProps();

  const label = props.children;
  const wordCount =
    typeof label === "string"
      ? label.trim().split(/\s+/).filter(Boolean).length
      : 0;
  const shouldWrap = wordCount > 3;
  const labelLength = typeof label === "string" ? label.length : 0;
  const fontSize = shouldWrap
    ? "sm"
    : labelLength > 14
      ? "sm"
      : labelLength > 9
        ? "md"
        : "inherit";

  return (
    <Box as="label" variant="unstyled" flex="1">
      <input {...input} />
      <Tooltip color='white' bg={colorMain} hasArrow label={`click to pay with ${props.value}`} fontSize={["1.2rem"]}>
        <Box
          {...checkbox}
          cursor="pointer"
          borderRadius="md"
          required
          px={4}
          py={shouldWrap ? 2 : 0}
          color={colorMain}
          outline={`.0rem solid ${colorMain}`}
          fontWeight="bold"
          bgColor="white"
          h={shouldWrap ? "auto" : "36px"}
          minH="36px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          whiteSpace={shouldWrap ? "normal" : "nowrap"}
          wordBreak={shouldWrap ? "break-word" : "normal"}
          overflow="hidden"
          textOverflow={shouldWrap ? "clip" : "ellipsis"}
          fontSize={fontSize}
          variant="unstyled"
          border="none"
          _checked={{
            color: "white",
            bg: colorMain,
            borderColor: "white",
            borderWidth: "2px",
          }}
        >
          {props.children}
        </Box>
      </Tooltip>
    </Box>
  );
}
